import { render, staticRenderFns } from "./CreateUserGroupPage.vue?vue&type=template&id=0e42d324&scoped=true"
import script from "./CreateUserGroupPage.vue?vue&type=script&lang=js"
export * from "./CreateUserGroupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e42d324",
  null
  
)

export default component.exports